// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vzpH","colBig":"styles_colBig__1-7rc","colSmall":"styles_colSmall__3wnlQ","shopifyNameWrapper":"styles_shopifyNameWrapper__3EzTP"};